<template>
  <div id="MailModal">
    <b-modal ref="mailModal" hide-footer hide-header size="md">
      <div class="d-block">
        <b-container>
          <b-row>
            <b-col class="font-weight-bold"> Bitte geben Sie Ihre E-Mail-Adresse an, mit der sie bei PayPal regestriert sind: </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="ml-1">PayPal E-Mail</b-col>
          </b-row>
          <b-row>
            <b-col class="mt-1"><b-form-input v-model="mail" placeholder="E-Mail" size="sm" @keyup.enter="startPayment" @change="validateData"></b-form-input></b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col><b-button size="sm" @click="startPayment">Bezahlen</b-button></b-col>
          </b-row>
          <b-row class="mt-2 text-danger" v-if="msg">
            <b-col>{{ msg }}</b-col>
          </b-row>
        </b-container>
      </div>

    </b-modal>
  </div>
</template>

<script>

export default {
  name: 'MailModal',
  components: { },
  created: function () {
  },
  data () {
    return {
      mail: null,
      msg: null
    }
  },
  methods: {
    startPayment () {
      this.msg = ''
      if (!this.mail) {
        this.msg = 'Bitte E-Mail-Adresse angeben.'
      } else {
        if (this.validateData()) {
          if (localStorage.custNo) {
            this.$emit('pay', this.mail)
          } else {
            alert('Customer not found')
            // this.$router.replace({ name: 'start' })
          }
        }
      }
    },
    validateData () {
      // eslint-disable-next-line no-control-regex
      let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
      if (!this.mail) {
        this.msg = 'Bitte E-Mail-Adresse angeben.'
        return false
      } else {
        if (!this.mail.match(regex)) {
          this.msg = 'Bitte eine gültige E-Mail-Adresse angeben.'
          return false
        }
      }
      this.msg = ''
      return true
    },
    show () {
      this.$refs['mailModal'].show()
    },
    hide () {
      this.$refs['mailModal'].hide()
    }
  }
}
</script>
